import { MotorCoverageActionTypes, } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const estimate = createAsyncMapAction(MotorCoverageActionTypes.ESTIMATE, p => p.userId);
export const cancelPolicy = createAsyncMapAction(MotorCoverageActionTypes.CANCEL_POLICY, p => p.policyId);
export const listEvents = createAsyncMapAction(MotorCoverageActionTypes.LIST_EVENTS, p => p.userId);
export const createQuote = createAsyncMapAction(MotorCoverageActionTypes.CREATE_QUOTE, p => p.userId);
export const createQuoteRPC = createAsyncMapAction(MotorCoverageActionTypes.CREATE_QUOTE_RPC, p => p.userId);
